import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Horse_show_in_series } from '../models/horse_show_in_series';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class HorseShowsInSeriesService {

  constructor(private http: HttpClient) { }


    public getList(horse_show_series_id: string) : Promise<Horse_show_in_series[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'credentialing/get_horse_shows_for_series/horse_show_series_id/' + horse_show_series_id).subscribe((response:any) => {
			if(response.type == 'credential_horse_show_list' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

}
